import type React from "react";
import type { Book } from "../../../app/books";

import { useTranslation } from "react-i18next";

type CoverImageProps = {
  book: Book;
};

export const CoverImage: React.FC<CoverImageProps> = ({ book }) => {
  const { t } = useTranslation();

  return (
    <figure className="px-6 py-6">
      <img src={book.cover ?? "/nocover.jpg"} alt={t("book.cover", book)} className="mx-auto h-96 object-cover" />
    </figure>
  );
};
